// extracted by mini-css-extract-plugin
module.exports = {"captcha":"SQ9Okmo_","verify":"LjIkm2tH","title":"JPPcx2_U","desc":"__6vgzcvn7"};